export default {
  productTable: {
    items: [],
    filteredRecords: 0,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
      search: '',
      send: true,
    },
  },
  generatedQAs: [],
  askedQAs: [],
};
